import { createAction, handleActions } from 'redux-actions';
import { Api } from '../../api/api';
import { fetchSubmitForm, fetchSubmitFormFailed, fetchSubmitFormSuccess, resetSubmitFormData } from "../common/submitForm";
import { UNAUTHORIZED } from './../common/handleApiCall';
import { logout, onForbidden } from '../account/login';

//- Actions
export const setResetPasswordEmail = createAction('RESET_PASSWORD_EMAIL_SET', email => email);
export const fetchSendResetPasswordEmail = createAction(
    'FETCH_SEND_RESET_PASSWORD_EMAIL',
    email => Api.sendResetPasswordEmail(email),
    () => ({
        apiCall: true,
        onSuccess: fetchSubmitFormSuccess,
        onFail: fetchSubmitFormFailed
    })
);
export const onResetPasswordSuccess = () => (dispatch) => {
    dispatch(logout());
    dispatch(fetchSubmitFormSuccess());
};
export const fetchResetPassword = createAction(
    'FETCH_RESET_PASSWORD',
    (token, password) => Api.resetPassword(token, password),
    () => ({
        apiCall: true,
        onSuccess: onResetPasswordSuccess,
        onFail: onSubmitFormFailed
    })
);

export const fetchChangePassword = (data) => (dispatch) => {
    dispatch(fetchSubmitForm());
    dispatch(onChangePassword(data));
};
export const onChangePasswordSuccess = () => (dispatch) => {
    dispatch(logout());
    dispatch(resetSubmitFormData());
};
export const onChangePassword = createAction(
    'FETCH_CHANGE_PASSWORD',
    (data) => Api.changePassword(data),
    () => ({
        apiCall: true,
        onSuccess: onChangePasswordSuccess,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const fetchUpdateEmail = (email) => dispatch => {
    dispatch(fetchSubmitForm());
    dispatch(onUpdateEmail(email));
};
export const onUpdateEmail = createAction(
    'FETCH_UPDATE_EMAIL',
    (email) => Api.changeEmail(email),
    () => ({
        apiCall: true,
        onSuccess: fetchSubmitFormSuccess,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const onSubmitChangeEmail = createAction(
    'FETCH_CHANGE_EMAIL_SUBMIT',
    (token) => Api.submitChangeEmail(token),
    () => ({
        apiCall: true,
        onSuccess: fetchSubmitFormSuccess,
        onFail:  (error) => (dispatch) => {
            if (error === UNAUTHORIZED) {
                dispatch(fetchSubmitFormFailed("IRRELEVANT_LINK_EMAIL"));
            } else {
                dispatch(fetchSubmitFormFailed(error));
            }
        }
    })
);

export const onSubmitFormFailed = (error) => (dispatch) => {
    if (error === UNAUTHORIZED) {
        dispatch(fetchSubmitFormFailed("IRRELEVANT_LINK"));
    } else {
        dispatch(fetchSubmitFormFailed(error));
    }
};

export const sendResetPasswordEmail = (email) => (dispatch) => {
    dispatch(fetchSubmitForm());
    dispatch(fetchSendResetPasswordEmail(email));
};

export const sendResetPassword = (token, password) => (dispatch) => {
    dispatch(fetchSubmitForm());
    dispatch(fetchResetPassword(token, password));
};

//- State
const initialState = {
    resetPasswordEmail: ''
};

//- Reducers
export default handleActions({
    RESET_PASSWORD_EMAIL_SET: (state, action) => {
        return { ...state, resetPasswordEmail: action.payload };
    }
}, initialState);

//- Selectors
export const getResetPasswordEmail = state => state.restoreAccount.resetPasswordEmail;


// WEBPACK FOOTER //
// ./src/reducers/account/restoreAccount.js